import { render, staticRenderFns } from "./DraftSurveys.vue?vue&type=template&id=6400c06c&"
import script from "./DraftSurveys.vue?vue&type=script&lang=js&"
export * from "./DraftSurveys.vue?vue&type=script&lang=js&"
import style0 from "./DraftSurveys.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports